module.exports = __webpack_public_path__ + "static/media/switch-friend-card.161715c5.wav";